import React from 'react';
import AppConfig from '../domain/AppConfig';
import AppService from '../service/AppService';

const appConfig:AppConfig = AppService.appConfig();

export default class EnvironmentIndicator extends React.Component {

  render() {
    let style = {};

    if (appConfig.envLocaleBalloon === undefined) {
      style = {display: 'none'};
    }

    return (
      <span style={style} className={`envBalloon ${appConfig.envLocaleBalloon}`}>{appConfig.envLocaleBalloon}</span>
    )
  }

}